export default __webpack_public_path__ + "static/byqwPCZM-99cfccec6cfcd26ccb1564c88387812f.svg";